export const PAGE_CONTENT_TABLES = {
  home: 'home_page_content',
  story: 'story_page_content',
  ministries: 'ministries_page_content',
  watch: 'watch_page_content',
  gallery: 'gallery_page_content',
  beliefs: 'beliefs_page_content',
  visit: 'visit_page_content',
  calendar: 'calendar_page_content',
  newhere: 'newhere_page_content',
};

export const PAGE_TABLE_NAMES = Object.values(PAGE_CONTENT_TABLES);

export function resolvePageSlug(fullKey) {
  const slug = fullKey.split('.')[0];
  return PAGE_CONTENT_TABLES[slug] ? slug : null;
}

export function toPageStorageKey(fullKey) {
  const slug = resolvePageSlug(fullKey);
  if (!slug) return null;
  return fullKey.slice(slug.length + 1);
}

export function toFullContentKey(pageSlug, storageKey) {
  return `${pageSlug}.${storageKey}`;
}

export function getTableForKey(fullKey) {
  const slug = resolvePageSlug(fullKey);
  return slug ? PAGE_CONTENT_TABLES[slug] : null;
}
